var _defs, _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "JUMO_Logo_blau",
    "data-name": "JUMO Logo blau",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 843.04 293.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: #fff;\r\n        stroke-width: 14.17px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: #fff;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #004489;\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #004489;\r\n        stroke-width: 13.93px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.08,
    y: 7.08,
    width: 828.87,
    height: 279.41,
    rx: 138.4,
    ry: 138.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.19,
    y: 10.49,
    width: 820.66,
    height: 272.59,
    rx: 136.02,
    ry: 136.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m204.48,67.89l-.22,118.63c.22,23.85-23.54,39.26-44.57,40.94-9.88.63-15.33.63-25.64-.21-14.92-.84-36.37-13.51-47.51-25.12v-63.76s15.98,13.3,17.45,14.99c3.15,1.9,10.93,8.23,16.62,10.57,4.2,2.1,7.36,2.74,11.56,2.31,6.93.22,9.25-4.22,9.25-12.46v-85.49l63.07-.41h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m284.78,68.3s.21,64.81,0,94.78c0,15.41,36.8,14.78,36.17-.22l.21-94.98,59.28.21.2,108.28c-.41,54.05-55.82,50.8-57.16,50.81-8.31.05-16.2.09-23.78.1s-14.32-.01-21.11-.1c-3.68-.05-53.51,5.13-53.94-50.38-.41-40.11,0-108.91,0-108.91l60.14.41h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m452.97,68.09s25.24,38.2,37.42,57.84c.63.21,38.46-56.57,39.3-58.04h50.25v158.53l-60.34-.22v-46.65l-29.01,47.49h0c-.63-.63-29-47.92-29-47.92,0,0,.62,33.99.2,47.07-17.23.22-59.71,0-59.71,0V68.09h50.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m680.42,64.48c81.57,0,76.31,50.03,76.31,82.75,0,44.53,6.73,82.54-77.78,82.54-84.95.21-78.63-40.75-78.84-79.59-.21-41.78-4.42-85.69,80.31-85.69h0Zm-19.55,82.53c0,13.94-1.68,37.58,18.5,37.58,21.45,0,18.91-21.1,18.91-38,0-17.73,2.96-38.42-19.33-38.42-20.18,0-18.08,27.02-18.08,38.84h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f97b264f027241e1cd4ded09532a31e0.svg";
export { ForwardRef as ReactComponent };